<template lang="html">
  <div class="question-navigator">
    <div class="text-caption font-weight-medium mb-2 grey--text text--darken-1">
      Navigasi Soal
    </div>
    <div ref="scroll" class="question-navigator__scroll">
      <div class="question-navigator__grid">
        <button
          v-for="n in total"
          :key="n"
          :ref="'btn-' + (n - 1)"
          type="button"
          class="question-navigator__btn"
          :class="btnClass(n - 1)"
          @click="$emit('navigate', n - 1)"
        >
          {{ n }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionNavigator',
  props: {
    total: {
      type: Number,
      required: true
    },
    currentIndex: {
      type: Number,
      default: 0
    },
    statuses: {
      type: Array,
      default: () => []
    }
  },
  watch: {
    currentIndex() {
      this.$nextTick(() => this.scrollCurrentIntoView())
    },
    total() {
      this.$nextTick(() => this.scrollCurrentIntoView())
    }
  },
  mounted() {
    this.scrollCurrentIntoView()
  },
  methods: {
    btnClass(index) {
      const status = this.statuses[index] || 'pending'
      return {
        'is-current': index === this.currentIndex,
        'is-answered': status === 'answered',
        'is-skipped': status === 'skipped',
        'is-pending': status === 'pending'
      }
    },
    scrollCurrentIntoView() {
      const ref = this.$refs['btn-' + this.currentIndex]
      const el = Array.isArray(ref) ? ref[0] : ref
      if (el && typeof el.scrollIntoView === 'function') {
        el.scrollIntoView({ block: 'nearest', behavior: 'smooth' })
      }
    }
  }
}
</script>

<style scoped>
.question-navigator {
  background: #fff;
  border-radius: 8px;
  padding: 12px;
  border: 1px solid #e0e0e0;
}

.question-navigator__scroll {
  max-height: min(60vh, 420px);
  overflow-y: auto;
  padding-right: 4px;
  padding-top: 10px;
  padding-left: 10px;
  scrollbar-width: thin;
  scrollbar-color: #bdbdbd transparent;
}

.question-navigator__scroll::-webkit-scrollbar {
  width: 6px;
}

.question-navigator__scroll::-webkit-scrollbar-thumb {
  background: #bdbdbd;
  border-radius: 3px;
}

.question-navigator__scroll::-webkit-scrollbar-track {
  background: transparent;
}

.question-navigator__grid {
  display: grid;
  grid-template-columns: repeat(5, 36px);
  gap: 8px;
}

.question-navigator__btn {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  border: 2px solid #e0e0e0;
  background: #fff;
  color: #424242;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  line-height: 1;
  padding: 0;
}

.question-navigator__btn:hover {
  border-color: var(--v-primary-base, #1976d2);
}

.question-navigator__btn.is-pending {
  background: #fff;
  color: #424242;
}

.question-navigator__btn.is-answered {
  background: #43a047;
  border-color: #43a047;
  color: #fff;
}

.question-navigator__btn.is-skipped {
  background: #e53935;
  border-color: #e53935;
  color: #fff;
}

.question-navigator__btn.is-current {
  box-shadow: 0 0 0 2px var(--v-primary-base, #1976d2);
  border-color: var(--v-primary-base, #1976d2);
}
</style>
